import { httpRequest } from "../../http";
import { FieldMapDocument } from "@models/fieldMap.model";
export class CommandGetFieldMap {
  async run(definitionId: number): Promise<FieldMapDocument> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/field-map/`;
    return httpRequest<FieldMapDocument>(url, { method: "GET" });
  }
}
